import styled from 'styled-components';
var DEFAULT_PROPS_TO_REMOVE = ['design', 'schema', 'config', 'components'];
export function styledWithoutNonHTMLProps(element, propsToNotForward) {
    if (propsToNotForward === void 0) { propsToNotForward = []; }
    return styled(element).withConfig({
        shouldForwardProp: function (prop, defaultValidatorFn) {
            return !DEFAULT_PROPS_TO_REMOVE.concat(propsToNotForward).includes(prop) && defaultValidatorFn(prop);
        },
    });
}
